import type { QTableColumn } from 'quasar';
export interface EventModelInput {
  id: string;
  name0: string;
  name1: string;
  name2: string;
  short_text: string;
  long_text: string;
  publish_time: string;
}
export interface EventModelAttributes {
  id: string;
  name0: string;
  name1: string;
  name2: string;
  short_text: string;
  long_text: string;
  publish_time: string;
}
export class EventModel {
  id: string;
  name0: string;
  name1: string;
  name2: string;
  short_text: string;
  long_text: string;
  publish_time: string;

  constructor(input?: EventModelInput) {
    this.id = input ? input.id : '';
    this.name0 = input ? input.name0 : '';
    this.name1 = input ? input.name1 : '';
    this.name2 = input ? input.name2 : '';
    this.short_text = input ? input.short_text : '';
    this.long_text = input ? input.long_text : '';
    this.publish_time = input ? input.publish_time : '';
  }

  getId(): string {
    return this.id;
  }
  getAttributes(): EventModelAttributes {
    return {
      id: this.id,
      name0: this.name0,
      name1: this.name1,
      name2: this.name2,
      short_text: this.short_text,
      long_text: this.long_text,
      publish_time: this.publish_time,
    };
  }
}
export type EventCollection = EventModel[];

export const EventTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'publish_time',
    label: '発生日時',
    align: 'left',
    field: 'publish_time',
    sortable: true,
  },
  {
    name: 'name0',
    label: 'カテゴリ大分類名',
    align: 'left',
    field: 'name0',
    sortable: true,
  },
  {
    name: 'name1',
    label: 'カテゴリ中分類名',
    align: 'left',
    field: 'name1',
    sortable: true,
  },
  {
    name: 'name2',
    label: 'カテゴリ小分類名',
    align: 'left',
    field: 'name2',
    sortable: true,
  },
];
